import { Toast } from "vant";

function origin_less() {
  // insert less.js and color.less
  const lessStyleNode = document.createElement("link");
  lessStyleNode.setAttribute("id", "themeStyle");
  lessStyleNode.setAttribute("rel", "stylesheet/less");
  lessStyleNode.setAttribute(
    "href",
    "/static/css/color.less?v=" + process.env.VERSION
  );
  document.body.insertBefore(lessStyleNode, document.body.firstChild);
}
export function less_init() {
  // 只有有换肤功能才需要
  // if(!configText.isShowSwitchTemplate){return}
  origin_less();
  const lessConfigNode = document.createElement("script");
  lessConfigNode.innerHTML = `
        window.less = {
          async: true,
          env: 'production',
          javascriptEnabled: true
        };
      `;
  document.body.appendChild(lessConfigNode);

  let inited_key = null;
  try {
    let locTheme = JSON.parse(localStorage.getItem("themeColorList"));
    if (locTheme && locTheme.key) {
      inited_key = locTheme.key;
    } else {
      localStorage.removeItem("themeColorList");
    }
  } catch (e) {}
  if (!inited_key) {
    const { pageTemplate } = configText;
    for (const key in pageTemplate) {
      const item = pageTemplate[key];
      if (item.selected) {
        inited_key = key;
        break;
      }
    }
  }
  const lessScriptNode = document.createElement("script");
  lessScriptNode.src =
    "https://cdnjs.cloudflare.com/ajax/libs/less.js/3.12.2/less.js";
  lessScriptNode.async = true;
  lessScriptNode.onload = () => {
    less_change(inited_key);
    lessScriptNode.onload = null;
  };
  document.body.appendChild(lessScriptNode);
}

export function less_change(temp_key, callback, colorconfig) {
  if (colorconfig) {
    setTimeout(() => {
      // console.log(window.less, '-----------------------------------111')
      if (window.less && typeof window.less.modifyVars === "function") {
        window.less
          .modifyVars(colorconfig)
          .then(() => {
            const themeStyleNode = document.getElementById("themeStyle");
            themeStyleNode && themeStyleNode.remove();
            if (callback) callback();
          })
          .catch(e => {
            console.log(e);
            Toast("Failed to update theme");
            if (callback) callback();
          });
      }
    }, 200);
    return;
  }
  if (!window.less || !temp_key) {
    return;
  }
  let config = {
    "@primaryColor": "#1f6efe",
    "@primary-color-hover": "#1f5efe",
    "@background-color": "#f0f6ff",
    "@button-bg-color": "#1f6efe",
    "@linearcolor":
      "linear-gradient(90deg, rgba(255, 25, 88, 1) 0%, rgba(239, 12, 12, 1) 100%)"
  };
  if (CONTROL_LESS && CONTROL_LESS[temp_key]) {
    config = CONTROL_LESS[temp_key];
    // console.log("使用动态颜色配置",temp_key,config)
    setTimeout(() => {
      // console.log(window.less, '-----------------------------------222')
      if (window.less && typeof window.less.modifyVars === "function") {
        window.less
          .modifyVars(config)
          .then(() => {
            const themeStyleNode = document.getElementById("themeStyle");
            themeStyleNode && themeStyleNode.remove();
            if (callback) callback();
          })
          .catch(e => {
            console.log(e);
            Toast("Failed to update theme");
            if (callback) callback();
          });
      }
    }, 200);
  }
}
